<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-body">
                    <div class="mb-3 row">
                        <label for="table-complete-search" class="col-xs-3 col-sm-auto col-form-label">Search</label>
                        <div class="col-xs-3 col-sm-auto">
                            <div class="row search">
                                <div class="col">
                                    <input id="table-complete-search" type="text" class="form-control" name="searchTerm"
                                        [value]="obj.searchTerm" (input)="actionSearch($event.target)">
                                </div>
                            </div>
                        </div>
                                                <div *ngIf="_id" class="col-xs-6 col-sm-auto" style="margin: auto;">
                                             
                                                </div>
<div *ngIf="_id" class="col-xs-2 col-sm-auto" >
    <button class="btn btn-primary" (click)="gotoAddCourse()">Add Course</button>
</div>
                        @if (obj.loading) {
                        <span class="col col-form-label">Loading...</span>
                        }
                    </div>

                    <div class="list-product table-responsive theme-scrollbar">
                        <div class="product-grid">
                            <div class="feature-products">
                                <div class="row">
                                    <div class="col-md-6 products-total">
                                        <div class="square-product-setting d-inline-block" href="javascript:void(0)"
                                            (click)="listOpens()">
                                            <a class="icon-grid m-0 list-layout-view">
                                                <app-feather-icons [icons]="'list'"></app-feather-icons>
                                            </a>
                                        </div>
                                        <span class="d-none-productlist filter-toggle" (click)="isShow =!isShow">Sort By
                                            <span class="ms-2">
                                                <app-feather-icons [class]="'toggle-data'"
                                                    [icons]="'chevron-down'"></app-feather-icons>
                                            </span>
                                        </span>
                                        <div class="grid-options d-inline-block">
                                            <ul>
                                                <li class="pointer" (click)="grid2s()"><a
                                                        class="product-2-layout-view"><span
                                                            class="line-grid line-grid-1 bg-primary"></span><span
                                                            class="line-grid line-grid-2 bg-primary"></span></a>
                                                </li>
                                                <li class="pointer" (click)="grid3s()"><a
                                                        class="product-3-layout-view"><span
                                                            class="line-grid line-grid-3 bg-primary"></span><span
                                                            class="line-grid line-grid-4 bg-primary"></span><span
                                                            class="line-grid line-grid-5 bg-primary"></span></a>
                                                </li>
                                                <li class="pointer" (click)="gridOpens()"><a
                                                        class="product-4-layout-view"><span
                                                            class="line-grid line-grid-6 bg-primary"></span><span
                                                            class="line-grid line-grid-7 bg-primary"></span><span
                                                            class="line-grid line-grid-8 bg-primary"></span><span
                                                            class="line-grid line-grid-9 bg-primary"></span></a>
                                                </li>
                                                <li class="pointer" (click)="grid6s()"><a
                                                        class="product-6-layout-view"><span
                                                            class="line-grid line-grid-10 bg-primary"></span><span
                                                            class="line-grid line-grid-11 bg-primary"></span><span
                                                            class="line-grid line-grid-12 bg-primary"></span><span
                                                            class="line-grid line-grid-13 bg-primary"></span><span
                                                            class="line-grid line-grid-14 bg-primary"></span><span
                                                            class="line-grid line-grid-15 bg-primary"></span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="product-wrapper-grid" [class.list-view]="listView">
                                @if(obj.itemList && obj.itemList.length<1){ 
                                    <div
                                        class="d-flex justify-content-center align-items-center vh-50">
                                        There are no result found.
                                    </div>
                                }
                                <div class="row">
                                    @for (item of obj.itemList; track item) {
                                    <div
                                      [class.col-xl-3]="col_xl_3"
                                      [class.col-xl-4]="xl_4"
                                      [class.col-sm-3]="col_sm_3"
                                      [class.col-xl-4]="col_xl_4"
                                      [class.col-sm-4]="col_sm_4"
                                      [class.col-xl-6]="col_xl_6"
                                      [class.col-sm-6]="col_sm_6"
                                      [class.col-xl-12]="col_xl_12"
                                      [class.col-xl-2]="col_xl_2"
                                    >
                                      <div class="card">
                                        <div class="product-box">
                                          <div class="product-img">
                                            @if (item.multimedia != null) {
                                            <img class="img-fluid w-100" [src]="item.multimedia" alt="" />
                                            }@else {
                                            <img
                                              class="img-fluid w-100"
                                              src="assets/homepage/courses/course1.png"
                                              alt=""
                                            />
                                            }
                                            <div class="product-hover">
                                              <ul>
                                                <a (click)="actionGoSection(item)"> <!-- [routerLink]="[section, item.id]" [queryParams]="{ type: type }" -->
                                                  <li>
                                                      <i class="icon-eye"></i>
                                                  </li>
                                                </a>
                                              </ul>
                                            </div>
                                          </div>
                                          <div class="product-details">
                                            <a>
                                              <h4>{{ item.name }}</h4>
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    }
                                  </div>
                            </div>
                    </div>
                    @if(obj.paginator){
                    <app-rounded-pagination [paginator]="obj.paginator"
                        (paginatorFind)="calculatePage()"></app-rounded-pagination>
                    }
                </div>
            </div>
        </div>
    </div>
</div>